import '@styles/frontend/main.scss';
import { CheckSalaryForm } from './check-salary-form';
import { DataVisualizer } from './check-salary-form-data-visualizer';

if (!customElements.get('check-salary-form')) {
  customElements.define('check-salary-form', CheckSalaryForm);
}
if (!customElements.get('check-salary-form-data-visualizer')) {
  customElements.define('check-salary-form-data-visualizer', DataVisualizer);
}

/**
 * Lazily initializes the React-powered Search Salary embed (if present on the page).
 */
const initSearchSalaryEmbed = async () => {
  if (!document.querySelector('[data-check-salary-render="search-embed"]')) {
    return;
  }

  try {
    await import('@scripts/frontend/search-salary-embed/init');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialize check-salary search embed.', error);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchSalaryEmbed, { once: true });
} else {
  void initSearchSalaryEmbed();
}

export { CheckSalaryForm, DataVisualizer };
